import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    placeholder: 'Напишите что-нибудь или введите / для команд...',
    nothingFound: 'Ничего не найдено',
    apply: 'Применить',
    remove: 'Удалить',
    replace: 'Заменить',
    cancel: 'Отмена',
    imageUploadBusy: 'Дождитесь окончания загрузки картинки',
    pastedImagesDropped: 'Картинки из буфера не вставляются — загрузите их файлом',
    notAnImage: 'Загрузите изображение (PNG, JPG, WEBP)',
    fileTooLarge: (maxMb: number) =>
      `Файл слишком большой: можно загрузить до ${maxMb} МБ. Сожмите картинку или выберите другую.`,
    // Слэш-меню
    text: 'Текст',
    textHint: 'Обычный текст',
    heading1: 'Заголовок 1',
    heading1Hint: 'Большой заголовок',
    heading2: 'Заголовок 2',
    heading2Hint: 'Средний заголовок',
    heading3: 'Заголовок 3',
    heading3Hint: 'Маленький заголовок',
    image: 'Картинка',
    imageHint: 'Загрузить изображение',
    bulletList: 'Список',
    bulletListHint: 'Маркированный список',
    orderedList: 'Нумерованный',
    orderedListHint: 'Нумерованный список',
    taskList: 'Чек-лист',
    taskListHint: 'Список задач',
    quote: 'Цитата',
    quoteHint: 'Блок цитаты',
    code: 'Код',
    codeHint: 'Блок кода',
    divider: 'Разделитель',
    dividerHint: 'Горизонтальная линия',
  },
  en: {
    placeholder: 'Write something or type / for commands…',
    nothingFound: 'Nothing found',
    apply: 'Apply',
    remove: 'Remove',
    replace: 'Replace',
    cancel: 'Cancel',
    imageUploadBusy: 'Wait for the current image upload to finish',
    pastedImagesDropped: "Images from the clipboard can't be pasted — upload them as files",
    notAnImage: 'Upload an image (PNG, JPG, WEBP)',
    fileTooLarge: (maxMb: number) =>
      `File is too large: the limit is ${maxMb} MB. Compress the image or choose another one.`,
    text: 'Text',
    textHint: 'Plain text',
    heading1: 'Heading 1',
    heading1Hint: 'Large heading',
    heading2: 'Heading 2',
    heading2Hint: 'Medium heading',
    heading3: 'Heading 3',
    heading3Hint: 'Small heading',
    image: 'Image',
    imageHint: 'Upload an image',
    bulletList: 'Bulleted list',
    bulletListHint: 'Bulleted list',
    orderedList: 'Numbered list',
    orderedListHint: 'Numbered list',
    taskList: 'Checklist',
    taskListHint: 'Task list',
    quote: 'Quote',
    quoteHint: 'Quote block',
    code: 'Code',
    codeHint: 'Code block',
    divider: 'Divider',
    dividerHint: 'Horizontal line',
  },
})
